import { render, staticRenderFns } from "./jingjiakaishi.vue?vue&type=template&id=71309f50&scoped=true"
import script from "./jingjiakaishi.vue?vue&type=script&lang=js"
export * from "./jingjiakaishi.vue?vue&type=script&lang=js"
import style0 from "./jingjiakaishi.vue?vue&type=style&index=0&id=71309f50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71309f50",
  null
  
)

export default component.exports